import React from 'react';

export default class PopupWrapper extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isDisplay: false,
			myLabel: ''
		};

		this.onpopstateFunc = null;
	}

	componentDidMount() {
		this.handleDisplay(this.props);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.display !== this.props.display) {
			this.handleDisplay(this.props);
		}
	}

	componentWillUnmount() {
		this.removePopstateListener();
	}

	removePopstateListener = () => {
		if (this.onpopstateFunc) {
			window.removeEventListener("popstate", this.onpopstateFunc);
			this.onpopstateFunc = null;
		}
	}

	handleDisplay = (props) => {
		if (props.display === true && this.state.isDisplay === false) {

			const myLabel = new Date().getTime() + "";

			this.removePopstateListener();

			this.onpopstateFunc = (event) => {
				console.log("onpopstateFunc called");

				if ((window.location.href + "").indexOf('#/' + myLabel) > -1) {
					return;
				}

				this.removePopstateListener();

				this.setState({
					isDisplay: false
				});

				if (typeof props.callBack === "function") {
					props.callBack();
				}
			};

			this.setState({
				isDisplay: true,
				myLabel
			});

			window.history.pushState(
				null,
				null,
				window.location.hash + '#/' + myLabel
			);

			window.addEventListener("popstate", this.onpopstateFunc);
		}

		// 外部关闭
		if (props.display === false && this.state.isDisplay === true) {
			this.removePopstateListener();

			this.setState({
				isDisplay: false
			});
		}
	}

	render() {
		return (
			<div
				style={{
					...this.props.style,
					display: this.state.isDisplay ? "block" : "none"
				}}
			>
				{this.props.children}
			</div>
		);
	}
}